import {
  FB_METRICS_PROPERTIES,
  IG_METRICS_PROPERTIES,
  LI_METRICS_PROPERTIES,
} from 'app/modules/insights/modules/pagePerformance/utils/metricProperty';
import { TYPE as PAGE_TYPE } from '@kontentino/kontentino-constants/Pages';

export type SocialPlatform = 'IG' | 'FB' | 'LI';

export interface MetricConfig {
  key: string;
  title: string;
  queryParameter?: string;
}

export interface PlatformMetrics {
  pagePerformance: MetricConfig[];
  postPerformance: MetricConfig[];
}

export const ANALYTICS_LITE_PAGE_PERFORMANCE: Record<number, MetricConfig[]> = {
  [PAGE_TYPE.INSTAGRAM]: [
    {
      key: IG_METRICS_PROPERTIES.reach.key,
      title: IG_METRICS_PROPERTIES.reach.title,
      queryParameter: IG_METRICS_PROPERTIES.reach.queryParameter,
    },
    {
      key: IG_METRICS_PROPERTIES.followerDemographics.key,
      title: IG_METRICS_PROPERTIES.followerDemographics.title,
      queryParameter: IG_METRICS_PROPERTIES.followerDemographics.queryParameter,
    },
    {
      key: IG_METRICS_PROPERTIES.bestTimeToPostAllTime.key,
      title: IG_METRICS_PROPERTIES.bestTimeToPostAllTime.title,
      queryParameter:
        IG_METRICS_PROPERTIES.bestTimeToPostAllTime.queryParameter,
    },
  ],
  [PAGE_TYPE.FACEBOOK]: [
    {
      key: FB_METRICS_PROPERTIES.audience.key,
      title: FB_METRICS_PROPERTIES.audience.title,
      queryParameter: FB_METRICS_PROPERTIES.audience.queryParameter,
    },
    {
      key: FB_METRICS_PROPERTIES.page_impressions.key,
      title: FB_METRICS_PROPERTIES.page_impressions.title,
      queryParameter: FB_METRICS_PROPERTIES.page_impressions.queryParameter,
    },
    {
      key: FB_METRICS_PROPERTIES.bestTimeToPostAllTime.key,
      title: FB_METRICS_PROPERTIES.bestTimeToPostAllTime.title,
      queryParameter:
        FB_METRICS_PROPERTIES.bestTimeToPostAllTime.queryParameter,
    },
  ],
  [PAGE_TYPE.LINKEDIN]: [
    {
      key: LI_METRICS_PROPERTIES.followers.key,
      title: LI_METRICS_PROPERTIES.followers.title,
      queryParameter: LI_METRICS_PROPERTIES.followers.queryParameter,
    },
    {
      key: LI_METRICS_PROPERTIES.engagement.key,
      title: LI_METRICS_PROPERTIES.engagement.title,
      queryParameter: LI_METRICS_PROPERTIES.engagement.queryParameter,
    },
    {
      key: LI_METRICS_PROPERTIES.bestTimeToPostAllTime.key,
      title: LI_METRICS_PROPERTIES.bestTimeToPostAllTime.title,
      queryParameter:
        LI_METRICS_PROPERTIES.bestTimeToPostAllTime.queryParameter,
    },
  ],
};
